import { render, staticRenderFns } from "./Full.vue?vue&type=template&id=abf9ee28&scoped=true&"
import script from "./Full.vue?vue&type=script&lang=js&"
export * from "./Full.vue?vue&type=script&lang=js&"
import style0 from "./Full.vue?vue&type=style&index=0&id=abf9ee28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abf9ee28",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
